// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coach-obj-metrics {
  margin: 12px 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(8, 119, 188, 0.25);
  background: rgba(8, 119, 188, 0.06);
}

.coach-obj-metrics--compact {
  padding: 8px;
}

.coach-obj-metrics__head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.coach-obj-metrics__hint,
.coach-obj-metrics__note,
.coach-obj-metrics__muted {
  font-size: 0.85rem;
  opacity: 0.85;
}

.coach-obj-metrics__error {
  color: #ef4444;
  font-size: 0.85rem;
}

.coach-obj-metrics__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.coach-obj-metrics__item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
}

.coach-obj-metrics__adjust {
  margin-top: 8px;
  font-size: 0.85rem;
}

.coach-obj-metrics__save {
  margin-top: 10px;
  padding: 6px 14px;
  border-radius: 8px;
  border: none;
  background: #0877bc;
  color: #fff;
  cursor: pointer;
}

.coach-obj-metrics__save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CoachObjectiveMetricPicker.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".coach-obj-metrics {\n  margin: 12px 0;\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(8, 119, 188, 0.25);\n  background: rgba(8, 119, 188, 0.06);\n}\n\n.coach-obj-metrics--compact {\n  padding: 8px;\n}\n\n.coach-obj-metrics__head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.coach-obj-metrics__hint,\n.coach-obj-metrics__note,\n.coach-obj-metrics__muted {\n  font-size: 0.85rem;\n  opacity: 0.85;\n}\n\n.coach-obj-metrics__error {\n  color: #ef4444;\n  font-size: 0.85rem;\n}\n\n.coach-obj-metrics__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.coach-obj-metrics__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.coach-obj-metrics__adjust {\n  margin-top: 8px;\n  font-size: 0.85rem;\n}\n\n.coach-obj-metrics__save {\n  margin-top: 10px;\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: none;\n  background: #0877bc;\n  color: #fff;\n  cursor: pointer;\n}\n\n.coach-obj-metrics__save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
